module.exports = __webpack_public_path__ + "img/hands_hero.40a465b6.svg";